import { useTranslation } from 'react-i18next';
import { PollCountProps } from './types';

export const PollCount = ({ pollCount }: PollCountProps) => {
    const { t } = useTranslation();

    return (
        <>
            {t('Insights.Polls.AmountText')}
            <span data-testid="pollCount" className="text-3xl font-medium pl-2">
                {pollCount}
            </span>
        </>
    );
};
